import { getVesselSize, getCommodities } from '@/api/vessel-charter.api';

export const FETCH_SIZE_BARGE = 'FETCH_SIZE_BARGE';
export const FETCH_SIZE_BARGE_LOADING = 'FETCH_SIZE_BARGE_LOADING';
export const FETCH_SIZE_BARGE_DONE = 'FETCH_SIZE_BARGE_DONE';
export const FETCH_SIZE_BARGE_ERROR = 'FETCH_SIZE_BARGE_ERROR';

export const FETCH_SIZE_LCT = 'FETCH_SIZE_LCT';
export const FETCH_SIZE_LCT_LOADING = 'FETCH_SIZE_LCT_LOADING';
export const FETCH_SIZE_LCT_DONE = 'FETCH_SIZE_LCT_DONE';
export const FETCH_SIZE_LCT_ERROR = 'FETCH_SIZE_LCT_ERROR';

export const FETCH_COMMODITIES = 'FETCH_COMMODITIES';
export const FETCH_COMMODITIES_LOADING = 'FETCH_COMMODITIES_LOADING';
export const FETCH_COMMODITIES_DONE = 'FETCH_COMMODITIES_DONE';
export const FETCH_COMMODITIES_ERROR = 'FETCH_COMMODITIES_ERROR';

export default {
  [FETCH_SIZE_BARGE](context) {
    context.commit(FETCH_SIZE_BARGE_LOADING);
    const type = 'barge';
    return getVesselSize(type)
      .then(response => {
        context.commit(FETCH_SIZE_BARGE_DONE, response);
      })
      .catch(error => {
        context.commit(FETCH_SIZE_BARGE_ERROR, error);
      });
  },

  [FETCH_SIZE_LCT](context) {
    context.commit(FETCH_SIZE_LCT_LOADING);
    const type = 'lct';
    return getVesselSize(type)
      .then(response => {
        context.commit(FETCH_SIZE_LCT_DONE, response);
      })
      .catch(error => {
        context.commit(FETCH_SIZE_LCT_ERROR, error);
      });
  },

  [FETCH_COMMODITIES](context) {
    context.commit(FETCH_COMMODITIES_LOADING);
    return getCommodities()
      .then(response => {
        context.commit(FETCH_COMMODITIES_DONE, response);
      })
      .catch(error => {
        context.commit(FETCH_COMMODITIES_ERROR, error);
      });
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/vessel-charter/actions.js